import AbstractGuestlistDetailsPageController from '../../guestlists/abstract-details-controller';

export default class AbstractRsvpDetailsPageController extends AbstractGuestlistDetailsPageController {

    constructor($scope, $injector) {
        super($scope, $injector);

        this.loading = true;
        this.currentRsvpId = null;
        this._updateNav();
    }

    $onInit() {
        const promisesToWaitFor = [
            new Promise((resolve) => resolve())
        ];
        if (this.stateParams.guestlist) {
            this.guestlist = this.stateParams.guestlist;
            this.currentGuestlistId = _.clone(this.guestlist.id);
            this._handleGuestlistSelect();
        } else {
            this.currentGuestlistId = _.clone(this.stateParams.gid);
            promisesToWaitFor.push(this._loadGuestlist());
        }

        if (this.stateParams.rsvp) {
            this.rsvp = this.stateParams.rsvp;
            this.currentRsvpId = this.rsvp.id;
            this._handleRsvpSelect();
        } else {
            this.currentRsvpId = _.clone(this.stateParams.id);
            promisesToWaitFor.push(this._loadRsvp());
        }

        return this.injector.get('$q')
            .all(promisesToWaitFor)
            .then(() => {
                this.loading = false;
                this._updateNav();
            })

        this._initWatchers();
    }

    _loadRsvp() {
        return this.api.get(`rsvps/${this.stateParams.id}?include=contact,parent,parent.contact`)
            .then(({data}) => {
                this.rsvp = data.data;
                this.stateParams.rsvp = _.cloneDeep(this.rsvp);
                this._handleRsvpSelect();

                return this.rsvp;
            })
    }

    _updateNav() {
        this.navHelper.triggerUpdate();

        this.navHelper.setTranslationsParamsForEntry('events.guestlists.details.main', {
            name: (this.loading || !this.guestlist) ? this.translate.instant('general.verbs.loading_dot') : this.guestlist.name
        })

        this.navHelper.setTranslationsParamsForEntry('events.guestlists.details.rsvp-details.main', {
            name: (this.loading || !this.rsvp) ? this.translate.instant('general.verbs.loading_dot') : this.rsvp.contact.data.full_name
        })
    }

    _handleRsvpSelect() {
        this._updateNav();
        this.contact = this.rsvp.contact.data;
    }

    _handleGuestlistSelect() {
        this._updateNav();
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/rsvps/details/abstract-details-controller.js